import {addHours, format} from "date-fns";
import {itCH} from "date-fns/locale";
import {utcToZonedTime} from "date-fns-tz";

class DateTimeUtils {
    lessonDurationFromCourse = (course) => {
        if(course != null){
            let splittedTime = course.localTime?.split(":");

            let date = new Date()
            date.setHours(splittedTime[0], splittedTime[1])
            date = new Date(date.getTime() + course.durationInMinutes * 60000)

            return `${date.getHours()}:${date.getMinutes()}`;
        }

        return ""
    }

    addMinutesToTime(timeString, minutesToAdd) {
        const [hours, minutes] = timeString.split(':');

        let currentHours = parseInt(hours);
        let currentMinutes = parseInt(minutes);

        currentMinutes += parseInt(minutesToAdd);

        currentHours += Math.floor(currentMinutes / 60);
        currentMinutes %= 60;

        return `${String(currentHours).padStart(2, '0')}:${String(currentMinutes).padStart(2, '0')}`;
    }

    getParticipantDob(participant) {
        let dob = participant.dob
        let dateFormDob = new Date(dob)

        return format(dateFormDob, "dd.MM.yyyy")
    }

    formatStringAsDate(dateString) {
        let date = Date.parse(dateString)
        return  format(date, "yyyy-MM-dd")
    }

    formatStartStringAsDate(dateString){
        let date = Date.parse(dateString)
        return  format(date, "dd.MM.yyyy")
    }

    formatCourseStartData(courseStart){
        return format(Date.parse(courseStart), "dd.MM.yyyy");
    }

    fromTimeMillisToDate(timeInMillis){
        return format(new Date(timeInMillis), "dd.MM.yyyy")
    }

    fromTimeMillisToDateTime(timeInMillis){
        return this.fromPublishDateToISOFormat(format(new Date(timeInMillis), "yyyy.MM.dd HH:mm:ss"))
    }

    fromDateToLocalFormat(dateString){
        let date = Date.parse(dateString)
        return  format(date, "dd.MM.yyyy HH:mm")
    }

    formatDateAsLocaleStart(dateString){
        let date = Date.parse(dateString)
        const timeZone = 'Europe/Zurich';

        const zonedDate = utcToZonedTime(date, timeZone);
        const dateWithOneHourAdded = addHours(zonedDate, 1);

        return format(dateWithOneHourAdded, "dd.MM.yyyy HH:mm", { locale: itCH });
    }

	convertToGMTFormat(dateTimeString) {
	    // Parse the input date and time string
	    let [dateString, timeString] = dateTimeString.split(' ');
	    let [year, month, day] = dateString.split('-').map(Number);
	    let [hours, minutes] = timeString.split(':').map(Number);

	    // Create a Date object with the provided date and time
	    let inputDate = new Date(Date.UTC(year, month - 1, day, hours, minutes));

	    // Get the browser's time zone offset in minutes
	    //let browserTimezoneOffset = new Date().getTimezoneOffset();

	    // Adjust the time by adding the browser's offset and 1 hour for GMT offset
	    inputDate.setMinutes(inputDate.getMinutes() + 60); // Adjusted for GMT+1 +1h summer time

	    // Format the adjusted date and time in the desired format using browser locale
	    let formattedDate = inputDate.toLocaleDateString(undefined, { day: '2-digit', month: '2-digit', year: 'numeric' });
	    let formattedTime = inputDate.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });

	    return `${formattedDate} ${formattedTime}`;
	}
	convertToZHTimezoneFormat(dateTimeString) {
		    // Parse the input date and time string
		    let [dateString, timeString] = dateTimeString.split(' ');
		    let [year, month, day] = dateString.split('-').map(Number);
		    let [hours, minutes] = timeString.split(':').map(Number);

			// Crea un oggetto Date in UTC
		    let utcDate = new Date(Date.UTC(year, month - 1, day, hours, minutes));

		    // Aggiunge 60 minuti per compensare l'offset nei dati salvati
		    utcDate.setMinutes(utcDate.getMinutes() + 60);

		    // Usa Intl.DateTimeFormat per formattare in fuso orario Europe/Zurich
		    let options = {
		        timeZone: 'Europe/Zurich',
		        year: 'numeric',
		        month: '2-digit',
		        day: '2-digit',
		        hour: '2-digit',
		        minute: '2-digit',
		        hour12: false,
		    };

		    let formatter = new Intl.DateTimeFormat('it-CH', options);
		    return formatter.format(utcDate);
		}

    // Data+ora di INIZIO CORSO (course.start). Stesso principio di convertUTCToLocalTime:
    // i dati sono salvati con offset fisso +02:00 -> si rilegge con +02:00 fisso (no ora legale),
    // cosi' l'orario mostrato coincide con quello inserito, sia in estate che in inverno.
    formatCourseStart(dateTimeString) {
        if (!dateTimeString) return "";
        let [dateString, timeString] = dateTimeString.split(' ');
        let [year, month, day] = dateString.split('-').map(Number);
        let [hours, minutes] = (timeString || "00:00").split(':').map(Number);
        let d = new Date(Date.UTC(year, month - 1, day, hours, minutes));
        d.setMinutes(d.getMinutes() + 120);
        let options = { timeZone: 'UTC', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hour12: false };
        return new Intl.DateTimeFormat('it-CH', options).format(d);
    }

    /* convertToGMTSwissFormat(dateTimeString) {
        // Parse the input date and time string
        let [dateString, timeString] = dateTimeString.split(' ');
        let [year, month, day] = dateString.split('-').map(Number);
        let [hours, minutes] = timeString.split(':').map(Number);

        // Create a Date object with the provided date and time
        let inputDate = new Date(Date.UTC(year, month - 1, day, hours, minutes));

        // Get the browser's time zone offset in minutes
        let browserTimezoneOffset = new Date().getTimezoneOffset();

        // Adjust the time by adding the browser's offset and 1 hour for GMT offset
        inputDate.setMinutes(inputDate.getMinutes() + browserTimezoneOffset + 60 + 60); // Adjusted for GMT+1 +1h summer time

        // Format the adjusted date and time in the desired format
        let dayFormatted = String(inputDate.getUTCDate()).padStart(2, '0');
        let monthFormatted = String(inputDate.getUTCMonth() + 1).padStart(2, '0');
        let yearFormatted = inputDate.getUTCFullYear();
        let hoursFormatted = String(inputDate.getUTCHours()).padStart(2, '0');
        let minutesFormatted = String(inputDate.getUTCMinutes()).padStart(2, '0');

        return `${dayFormatted}.${monthFormatted}.${yearFormatted} ${hoursFormatted}:${minutesFormatted}`;
    } */

    /* convertToGMTTimeFormat(timeString) {
        let [hours, minutes] = timeString.split(':').map(Number);

        // Create a Date object with the provided date and time
        let inputDate = new Date(Date.UTC(hours, minutes));

        // Get the browser's time zone offset in minutes
        let browserTimezoneOffset = new Date().getTimezoneOffset();

        // Adjust the time by adding the browser's offset and 1 hour for GMT offset
        inputDate.setMinutes(inputDate.getMinutes() + browserTimezoneOffset + 60); // Adjusted for GMT+1

        // Format the adjusted date and time in the desired format using browser locale
        let formattedTime = inputDate.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });

        return `${formattedTime}`;
    } */

    getBrowserCurrentTimeZoneOffset(){
        const currentDate = new Date();
        const timezoneOffset = currentDate.getTimezoneOffset();

        const hoursOffset = Math.abs(Math.floor(timezoneOffset / 60));
        const minutesOffset = Math.abs(timezoneOffset % 60);

        return`${timezoneOffset >= 0 ? '-' : '+'}${hoursOffset.toString().padStart(2, '0')}:${minutesOffset.toString().padStart(2, '0')}`;
    }

    fromDayInfoToCustomDate(dayInfo) {
        const { day, start, end } = dayInfo;
        const [dayn, month, year] = day.split('/');
        const formattedDate = `${year}:${month}:${dayn}${start && end ? ` ${start}:00` : ''}`;

        return new Date(formattedDate);
    }

    fromPublishDateToISOFormat(publishDate) {
        const [datePart, timePart] = publishDate.split(' ');
        const [year, month, day] = datePart.split('.');
        const [hour, minute, second] = timePart.split(':');

        return new Date(`${year}-${month}-${day}T${hour}:${minute}:${second}`).toISOString();
    }

    fromDateToDayOfWeek(date){
        const actualDate = new Date(date);
        let dateString = format(actualDate, 'EEEE', { locale: itCH });
        return dateString.charAt(0).toUpperCase() + dateString.slice(1)
    }

    convertUTCToLocalTime(utcTimeString) {
        if (!utcTimeString) return "";
        let [hours, minutes] = utcTimeString.split(':').map(Number);

        let utcDate = new Date(Date.UTC(0, 0, 0, hours, minutes));

        // Gli orari sono salvati con offset FISSO +02:00 (vedi salvataggio in adminEditCourse).
        // Si rilegge con lo stesso +02:00 fisso: NIENTE ora legale ne' fuso del browser,
        // altrimenti in estate l'offset viene contato due volte (+1h di troppo).
        utcDate.setMinutes(utcDate.getMinutes() + 120);

        return utcDate.toLocaleTimeString('it-CH', { hour: '2-digit', minute: '2-digit', timeZone: 'UTC' });
    }

    addOneYearToCurrentDate() {
        const currentDate = new Date();
        const newDate = new Date(currentDate);
        newDate.setFullYear(currentDate.getFullYear() + 1);
        return format(newDate, "yyyy-MM-dd HH:mm");
    }

    getEmissionDateFromExpiring(validUntil) {
        const newDate = new Date(validUntil);
        newDate.setFullYear(newDate.getFullYear() - 1);
        return format(newDate, "yyyy-MM-dd");
    }

    formatDateReport(dateString) {
        const date = new Date(dateString);

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = '00';
        const minutes = '00';

        return `${year}-${month}-${day} ${hours}:${minutes}`;
    }
}

export default new DateTimeUtils();